import { render, staticRenderFns } from "./chooseSongClassification.vue?vue&type=template&id=694c7f47&scoped=true"
import script from "./chooseSongClassification.vue?vue&type=script&lang=js"
export * from "./chooseSongClassification.vue?vue&type=script&lang=js"
import style0 from "./chooseSongClassification.vue?vue&type=style&index=0&id=694c7f47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694c7f47",
  null
  
)

export default component.exports